import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public auth: AuthService) {}

  canActivate(): Observable<boolean> {
    return this.auth.isAuthenticated().pipe(
      map((authenticated) => {
        if (!authenticated) {
          this.auth.redirectToLogin();
        }
        return authenticated;
      })
    );
  }
}
